import { noticeError, addPageAction } from "@src/helpers/monitoring";

export const adobeDataLeakDebugger = s => {
  try {
    s.lastTrackingCallVars = {};

    s.registerPreTrackCallback(() => {
      s.lastTrackingCallVars = {};
      s.linkTrackVars.split(",").forEach(varKey => {
        s.lastTrackingCallVars[varKey] = s[varKey];
      });
    });

    window.addEventListener("load", () => {
      try {
        const trackingAlreadyFired = s.account && window["s_i_" + s.account];

        if (trackingAlreadyFired) {
          const currentValue = s.eVar9;
          const previousValue =
            s.lastTrackingCallVars && s.lastTrackingCallVars.eVar9;

          if (previousValue !== currentValue) {
            s.linkTrackEvents = "";
            s.linkTrackVars = s.apl(s.linkTrackVars, "eVar9", ",", 1);
            s.tl(true, "o", "experiment tracking");

            addPageAction("adobeLeakedData", {
              pageName: s.pageName,
              ...s.lastTrackingCallVars
            });
          }
        }
      } catch (error) {
        noticeError(error, { errorSource: "adobeDebugging" });
      }
    });
  } catch (error) {
    noticeError(error, { errorSource: "adobeDebugging" });
  }
};

export const ADOBE_BEACON_PROBE_TIMEOUT_MS = 8000;

export const probeAdobeBeaconState = (
  s = window.s,
  timeoutMs = ADOBE_BEACON_PROBE_TIMEOUT_MS
) => {
  return new Promise(resolve => {
    let timer;
    try {
      const trackingServer = s && (s.trackingServerSecure || s.trackingServer);
      if (!trackingServer) return resolve("unknown");

      const url = `https://${trackingServer}/b/ss/${s.account}/1/JS-2.1.0/s_canary?AQB=1&ndh=1&t=${Date.now()}`;

      const controller = new AbortController();
      let timedOut = false;
      timer = setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, timeoutMs);

      fetch(url, {
        mode: "no-cors",
        keepalive: true,
        cache: "no-store",
        signal: controller.signal
      })
        .then(() => {
          clearTimeout(timer);
          resolve("not_blocked");
        })
        .catch(() => {
          clearTimeout(timer);
          const state = timedOut ? "unknown" : "blocked";
          resolve(state);
        });
    } catch (error) {
      clearTimeout(timer);
      noticeError(error, { errorSource: "adobeDebugging" });
      resolve("unknown");
    }
  });
};
